import { useSelector } from 'react-redux'

export const useFrameAdvisorUserProfile = () => {
  return useSelector(s => s.frameAdvisor.fsaInfo) || undefined
}
